import { TweenLite } from 'gsap'

const show = (element, options) => {
  if ($(element).hasClass('kill') === false) {
    TweenLite.to(element, 1.2, {
      y: options.y,
      autoAlpha: 1,
      ease: options.ease
    })
  }
}

const hide = (element, options) => {
  TweenLite.to(element, 1.2, {
    y: options.y,
    autoAlpha: 0,
    ease: options.ease
  })
}

const tweenX = (element, options) => {
  if ($(element).hasClass('kill') === false) {
    TweenLite.fromTo(
      element,
      2.4,
      {
        x: options.x,
        autoAlpha: 0
      },
      {
        x: 0,
        autoAlpha: 1,
        ease: options.ease,
        onStart: function() {
          $(element).addClass('kill')
        }
      }
    )
  }
}

const tweenY = (element, options) => {
  if ($(element).hasClass('kill') === false) {
    TweenLite.fromTo(
      element,
      2.4,
      {
        y: options.y,
        autoAlpha: 0
      },
      {
        y: 0,
        autoAlpha: 1,
        ease: options.ease,
        onStart: function() {
          $(element).addClass('kill')
        }
      }
    )
  }
}

export { show, hide, tweenX, tweenY }
